import {
  STR_MUTATION_ID_UPDATE_STOREFRONT,
  STR_MUTATION_UPDATE_PRODUCT,
  STR_MUTATION_ADD_TO_CART,
  STR_MUTATION_REMOVE_FROM_CART,
  STR_MUTATION_UPDATE_ORDER,
  STR_MUTATION_RESET_CART_STATE,
  STR_MUTATION_RESET_ORDER_STATE,
  STR_MUTATION_RESET_INVENTORY_STATE,
  STR_MUTATION_SET_PARENT_PASSCODE,
  STR_MUTATION_SET_SHIPPING_ADDRESS_COUNTRY
} from "./mutation-types";

import * as api from "../api";
import {
  defaultOrderState,
  defaultCartState,
  defaultInventoryState
} from "./index";
import { SET_CONFIG_OPTIONS } from "../../../vuex/modules/ui/mutation-types";

export default {
  async getStorefrontCatalog({ commit }, inStrStorefrontId) {
    const oRes = await api.getStorefrontCatalog(inStrStorefrontId);
    if (oRes.id) {
      commit(STR_MUTATION_ID_UPDATE_STOREFRONT, oRes);
    }

    if (oRes.products) {
      oRes.products.forEach(product => {
        commit(STR_MUTATION_UPDATE_PRODUCT, product);
      });
    }
    if (oRes.config) {
      commit(SET_CONFIG_OPTIONS, oRes.config);
    }
    // lock shipping address form to the storefront country
    // since we only support domestic shipping at the moment
    if (oRes.country_code) {
      commit(STR_MUTATION_SET_SHIPPING_ADDRESS_COUNTRY, oRes.country_code);
    }
  },

  async createOrder({ getters, commit }, cartItems) {
    const oRes = await api.createOrder(getters.getStorefrontId, cartItems);
    if (oRes.id && oRes.attributes) {
      oRes.attributes.id = oRes.id;
      commit(STR_MUTATION_UPDATE_ORDER, oRes.attributes);
    }
  },

  async fetchOrder({ commit }, orderId) {
    const oRes = await api.getOrder(orderId);
    if (oRes.id && oRes.attributes) {
      oRes.attributes.id = oRes.id;
      commit(STR_MUTATION_UPDATE_ORDER, oRes.attributes);
    }
  },

  async addKidToOrder({ commit }, { orderId, kidId }) {
    const oRes = await api.addKidToOrder(orderId, kidId);
    if (oRes.id && oRes.attributes) {
      oRes.attributes.id = oRes.id;
      commit(STR_MUTATION_UPDATE_ORDER, oRes.attributes);
    }
  },

  async removeKidFromOrder({ commit }, { orderId, kidId }) {
    const oRes = await api.removeKidFromOrder(orderId, kidId);
    if (oRes.id && oRes.attributes) {
      oRes.attributes.id = oRes.id;
      commit(STR_MUTATION_UPDATE_ORDER, oRes.attributes);
    }
  },

  async updateDeliveryMethod({ commit }, { orderId, isShipped, isPickup }) {
    const oRes = await api.updateDeliveryMethod(orderId, isShipped, isPickup);
    if (oRes.id && oRes.attributes) {
      oRes.attributes.id = oRes.id;
      commit(STR_MUTATION_UPDATE_ORDER, oRes.attributes);
    }
  },

  async updateOrderItems({ commit }, { orderId, cartItems }) {
    const oRes = await api.updateOrderItems(orderId, cartItems);
    if (oRes.id && oRes.attributes) {
      oRes.attributes.id = oRes.id;
      commit(STR_MUTATION_UPDATE_ORDER, oRes.attributes);
    }
  },

  async updateOrderAddress({ commit }, { orderId, oAddress }) {
    const oRes = await api.setOrderAddress(orderId, oAddress);
    if (oRes.id && oRes.attributes) {
      oRes.attributes.id = oRes.id;
      commit(STR_MUTATION_UPDATE_ORDER, oRes.attributes);
    }
  },

  async updateShippingAddress({ commit }, { orderId, oAddress }) {
    const oRes = await api.setOrderShippingAddress(orderId, oAddress);
    if (oRes.id && oRes.attributes) {
      oRes.attributes.id = oRes.id;
      commit(STR_MUTATION_UPDATE_ORDER, oRes.attributes);
    }
  },

  addItemToCart({ commit }, inStrProductId) {
    commit(STR_MUTATION_ADD_TO_CART, inStrProductId);
  },

  removeItemFromCart({ commit }, inStrProductId) {
    commit(STR_MUTATION_REMOVE_FROM_CART, inStrProductId);
  },

  setParentPasscode: ({ commit }, inStrPasscode) => {
    commit(STR_MUTATION_SET_PARENT_PASSCODE, inStrPasscode);
  },

  resetCartState: ({ commit }) => {
    commit(STR_MUTATION_RESET_CART_STATE, defaultCartState());
  },

  resetOrderState: ({ commit }) => {
    commit(STR_MUTATION_RESET_ORDER_STATE, defaultOrderState());
  },

  resetInventoryState: ({ commit }) => {
    commit(STR_MUTATION_RESET_INVENTORY_STATE, defaultInventoryState());
  }
};
